<template>
  <div class="tbqd twoBox">
    <myClock class="lf" :shenyu="shenyu" :key="shenyu" cId="c1"></myClock>
  </div>
</template>
<script>
import myClock from "../components/clock/clock";
export default {
  name: "tbqd",
  props: ["djlcId", "djs"],
  components: {
    myClock,
  },
  data() {
    return {
      shenyu: 0,
    };
  },
  mounted() {
    this.shenyu = this.djs;
  },
};
</script>
<style lang="less" scoped>
.tbqd {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>